import {
  httpServices,
  type OperationsSchema,
  type OperationType,
  type QueryFnParams
} from '@libs/data-access/queries'

import type {
  CompensatoryRestCounterType,
  RestCounterType
} from '../types/RestCounter'

export type CreateOperationOptions = QueryFnParams<{
  pathParams: { type: RestCounterType }
  payload: {
    user_contract_id: number
    amount_in_minutes?: number
    amount_in_days?: number
    description?: string
    // rest_attributes are sent when we create a  absence from the planning page
    rest_attributes?: {
      rest_type: CompensatoryRestCounterType
      starts_at: string
      ends_at: string
      user_contract_id: number
      note: string
    }
  }
}>
/**
 * Create a batch of  operations
 */
export const createRestCounterOperation = async (
  opts: CreateOperationOptions
) => {
  const response = await httpServices.core.post<OperationsSchema>(
    `/${opts.pathParams.type}/operations`,
    opts?.payload
  )
  return response.data
}

export type UpdateOperationOptions = QueryFnParams<{
  pathParams: { type: RestCounterType }
  payload: {
    operations: {
      user_contract_id: number
      pay_period_id: number
      percentage: number
      report_id: number
      type: OperationType
      amount_in_minutes?: number
      amount_in_days?: number
    }[]
  }
}>
/**
 * Update a batch of operations
 */
export const updateRestCounterOperation = async (
  opts: UpdateOperationOptions
) => {
  const response = await httpServices.core.put<OperationsSchema>(
    `/${opts.pathParams.type}/operations`,
    opts?.payload
  )
  return response.data
}
